import * as api from '../api/qaErrors.api';
import { QaErrorsList } from '../types/QaErrors';
import { ScriptState } from '../types/ScriptState';
import { getApplicationsName } from 'src/enums/applicationsName';

export type StatusReason = {
  value: number;
  label: string;
};

export type AllStatusReasons = {
  activateReasons: StatusReason[];
  deactivateReasons: StatusReason[];
};

export const getQaErrors = async (params: QaErrorsList.Request): Promise<QaErrorsList.Response> => {
  const data = await api.getQaErrors(params);
  return {
    ...data,
    errorsList: data.errorsList.map((item) => ({
      ...item,
      applicationName: getApplicationsName(item.applicationName) ?? item.applicationName,
    })),
  };
};

export const getScriptState = async (params: ScriptState.Params): Promise<ScriptState> => {
  const data = await api.getScriptState(params);
  const currentState = String(data.currentState || '');
  return {
    ...data,
    currentState: currentState.replace(/<br\s*[/]?>\s*/g, ' '),
  };
};

export const getAppsFilter = async () => {
  const { apps = [] } = await api.getAppsFilter();
  return apps
    .map((app) => ({ ...app, appName: getApplicationsName(app.appName) ?? app.appName }))
    .sort((a, b) => a.appName.localeCompare(b.appName));
};

export const getSideCodesFilter = async () => {
  const { siteCodes = [] } = await api.getSideCodesFilter();
  return siteCodes.sort();
};

export const getScriptNamesFilter = async () => {
  const { scriptNames = [] } = await api.getScriptNamesFilter();
  return scriptNames.sort();
};

export const getErrorCodesFilter = async () => {
  const { errorCodes = [] } = await api.getErrorCodesFilter();
  return errorCodes.sort((a, b) => a - b);
};

export const getScriptStatusReasons = async (isActive: boolean): Promise<StatusReason[]> => {
  const { scriptStatusReasons } = await api.getScriptStatusReasons(isActive);
  return scriptStatusReasons.map((item) => ({
    value: item.statusId,
    label: item.description,
  }));
};

export const getAllScriptStatusReasons = async (): Promise<AllStatusReasons> => {
  const [activateReasons, deactivateReasons] = await Promise.all([
    getScriptStatusReasons(true),
    getScriptStatusReasons(false),
  ]);
  return { activateReasons, deactivateReasons };
};
